import { Injectable } from '@angular/core';
declare const FlutterWebView: any;

declare global {
  interface Window {
    FlutterChannel?: {
      postMessage: (message: string) => void;
    };
  }
}
@Injectable({
  providedIn: 'root'
})
export class FlutterChannelService {

  constructor() { }

  sendDataToFlutter(data: any) {
    if (window.FlutterChannel && data) {
      const dataAsString = JSON.stringify(data);
      window.FlutterChannel.postMessage(dataAsString);
    } else {
      console.log('FlutterChannel is not available or data is invalid.');
    }
  }
}
